import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import styles from './Auth.module.css';

const formatErrorDetails = (details) => {
  if (!details) return '';
  if (typeof details === 'string') return details;

  try {
    return JSON.stringify(details, null, 2);
  } catch (error) {
    return String(details);
  }
};

const Login = ({ onSwitchToRegister }) => {
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    
    // 清除对应字段的错误
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.username.trim()) {
      newErrors.username = '请输入用户名';
    } else if (formData.username.length < 3) {
      newErrors.username = '用户名至少3个字符';
    }

    if (!formData.password) {
      newErrors.password = '请输入密码';
    } else if (formData.password.length < 6) {
      newErrors.password = '密码至少6个字符';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    setLoading(true);
    try {
      const result = await login(formData.username, formData.password);
      
      if (result.success) {
        // 登录成功，AuthContext会自动更新状态，App.js会重定向
        console.log('登录成功');
        setErrors({});
      } else {
        setErrors({
          general: result.message || '登录失败',
          generalDetail: formatErrorDetails(result.debugInfo)
        });
      }
    } catch (error) {
      setErrors({
        general: '登录失败，请重试',
        generalDetail: formatErrorDetails(error?.stack || error?.message)
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.authContainer}>
      <div className={`${styles.authCard} card`}>
        <div className={styles.authHeader}>
          <h1 className={styles.authTitle}>欢迎回来</h1>
          <p className={styles.authSubtitle}>登录您的账户继续阅读</p>
        </div>

        <form className={styles.authForm} onSubmit={handleSubmit}>
          {errors.general && (
            <div className={`${styles.errorMessage} ${styles.generalError}`}>
              {errors.general}
            </div>
          )}
          {errors.generalDetail && (
            <pre className={`${styles.errorMessage} ${styles.errorDetail}`}>
              {errors.generalDetail}
            </pre>
          )}

          <div className={styles.formGroup}>
            <label htmlFor="username" className={styles.formLabel}>
              用户名
            </label>
            <input
              type="text"
              id="username"
              name="username"
              className={`${styles.formInput} ${errors.username ? styles.error : ''}`}
              placeholder="请输入用户名"
              value={formData.username}
              onChange={handleChange}
              disabled={loading}
            />
            {errors.username && (
              <div className={styles.errorMessage}>{errors.username}</div>
            )}
          </div>

          <div className={styles.formGroup}>
            <label htmlFor="password" className={styles.formLabel}>
              密码
            </label>
            <input
              type="password"
              id="password"
              name="password"
              className={`${styles.formInput} ${errors.password ? styles.error : ''}`}
              placeholder="请输入密码"
              value={formData.password}
              onChange={handleChange}
              disabled={loading}
            />
            {errors.password && (
              <div className={styles.errorMessage}>{errors.password}</div>
            )}
          </div>

          <button
            type="submit"
            className={`${styles.authSubmitBtn} btn btn-primary`}
            disabled={loading}
          >
            {loading ? '登录中...' : '登录'}
          </button>
        </form>

        <div className={styles.authFooter}>
          <p className={styles.authSwitchText}>
            还没有账户？
            <button
              type="button"
              className={styles.authSwitchBtn}
              onClick={onSwitchToRegister}
              disabled={loading}
            >
              立即注册
            </button>
          </p>
        </div>

        <div className={styles.authDemo}>
          <p className={styles.demoText}>演示账户</p>
          <div className={styles.demoAccounts}>
            <button
              type="button"
              className={`${styles.demoBtn} btn btn-secondary`}
              onClick={() => setFormData({ username: 'demo', password: '123456' })}
              disabled={loading}
            >
              使用演示账户
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
